import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { GroupImportInsertStudentsRequest } from "../../services/GroupImportInsertStudentsRequest";
import { GroupImportLoadDataRequest } from "../../services/GroupImportLoadDataRequest";
import { GroupsService } from "../../services/groups.service";
import { GroupImportColumnTableComponent } from "./group-import-column-table/group-import-column-table.component";
import { GroupImportStudentDataTableComponent } from "./group-import-student-data-table/group-import-student-data-table.component";

@Component({
	selector: "app-import-group-data",
	templateUrl: "./import-group-data.component.html",
	styleUrls: ["./import-group-data.component.css"],
})
export class ImportGroupDataComponent implements OnInit {
	constructor(
		public ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private groupService: GroupsService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.SetStatus(0);

		this.SelectedGroup = this.dialogConfig.data.SelectedGroup;
		this.lstGroup = this.dialogConfig.data.lstGroup;
	}

	////////////////////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////////////////////

	FileName: string = "";
	File: File;
	TextData: any;
	ImportStatusID: any = 0;
	ImportStatusDesc: string = "Open Import File.";
	ImportStatusColor: string = "red";
	lstImportStatus: any = [
		//0
		{
			Desc: "Open Import File",
			Color: "Red",
		},

		//1
		{
			Desc: "Checking Format...",
			Color: "Blue",
		},

		//2
		{
			Desc: "Reading File...",
			Color: "Blue",
		},

		//3
		{
			Desc: "Select Column Types (Waiting for User Input)",
			Color: "Orange",
		},

		//4
		{
			Desc: "Checking Input...",
			Color: "Blue",
		},

		//5
		{
			Desc: "Select a Group to Add Students to (Waiting for User Input)",
			Color: "Orange",
		},

		//6
		{
			Desc: "Loading Student Data...",
			Color: "Blue",
		},

		//7
		{
			Desc: "Confirm Group Action and Create Group Options (Waiting for User Input)",
			Color: "Orange",
		},

		//8
		{
			Desc: "Adding Students to Group(s)...",
			Color: "Blue",
		},

		//9
		{
			Desc: "Students added successfully!",
			Color: "Green",
		},
	];

	ShowColumnTable: boolean = false;
	ShowStudentTable: boolean = false;

	lstColumnTable: any = [];
	lstStudentTable: any = [];

	Format: string = "Invalid";

	errorMessage: string = "";

	@ViewChild(GroupImportColumnTableComponent)
	colRef: GroupImportColumnTableComponent;

	@ViewChild(GroupImportStudentDataTableComponent)
	studentRef: GroupImportStudentDataTableComponent;

	IsSingleGroup: boolean = false;
	SelectedGroup: any;
	lstGroup: any = [];

	AddGroupActions: boolean = false;
	CreateGroupIfNotExists: boolean = false;

	////////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////////////////////////////
	onSelectFile() {
		document.getElementById("ImportFileInput").click();
	}

	onClose() {
		this.ref.close(0);
	}
	onCloseSuccess() {
		this.ref.close(1);
	}

	onFinishSelectColumns() {
		this.IsSingleGroup = false;

		this.errorMessage = "";
		//
		//#reigon Error Handling
		//
		this.SetStatus(4);

		//If Single Column, Need PersonID or Student ID
		if (this.Format == "SingleLine") {
			if (this.colRef.OptArray[0] < 0 && this.colRef.OptArray[0] > 1) {
				this.errorMessage = "Invalid Columns. For a single list of IDs you must select either PersonID or StudentID (in the dropdown)";
				this.SetStatus(3);
				this.IsSingleGroup = false;
				return;
			} else {
				this.IsSingleGroup = true;
				this.SetStatus(5);
				return;
			}
		}

		//If Multiple Column
		else {
			//Must have StudentID or PersonID
			var MainIDExists = false;
			var GroupIDExists = false;
			for (var z = 0; z < this.colRef.OptArray.length; z++) {
				var next = this.colRef.OptArray[z];

				if (next == 0 || next == 1) {
					MainIDExists = true;
				} else if (next == 2 || next == 3) {
					GroupIDExists = true;
				}
			}

			if (MainIDExists == false) {
				this.errorMessage = "Invalid Columns. Must set one of the columns to be PersonID or StudentID";
				this.SetStatus(3);
				this.IsSingleGroup = false;
				return;
			} else if (GroupIDExists == false) {
				this.IsSingleGroup = true;
				this.SetStatus(5);
				return;
			}
		}

		//#endregion
		//

		this.LoadStudentData();
	}

	onFinishSelectGroup() {
		this.errorMessage = "";

		if (this.SelectedGroup != null) {
			this.LoadStudentData();
		} else {
			this.errorMessage = "Select a Group";
			return;
		}
	}

	LoadStudentData() {
		this.SetStatus(6);

		//
		//#region Process Options
		//
		var lstPIDs: number[] = [];
		var lstSIDs: string[] = [];
		var lstGIDs: number[] = [];
		var lstGNs: string[] = [];

		var PersonCol = -1;
		var StudentCol = -1;
		var GroupIDCol = -1;
		var GroupNameCol = -1;

		//
		// Get Columns
		//
		for (var z = 0; z < this.colRef.OptArray.length; z++) {
			var next = this.colRef.OptArray[z];

			if (next == 0) {
				PersonCol = z;
			} else if (next == 1) {
				StudentCol = z;
			} else if (next == 2) {
				GroupNameCol = z;
			} else if (next == 3) {
				GroupIDCol = z;
			}
		}

		//
		// Create Parms Lists
		//
		for (var z = 0; z < this.lstColumnTable.length; z++) {
			var next = this.lstColumnTable[z];

			if (PersonCol >= 0) {
				var pNum = -1;

				try {
					pNum = Number(next[PersonCol]);

					if (pNum == undefined || pNum == null || Number.isNaN(pNum)) {
						pNum = -1;
					}
				} catch (e) {
					e.toString();
					pNum = -1;
				}

				if (pNum == undefined || pNum == null || Number.isNaN(pNum)) {
					pNum = -1;
				}

				lstPIDs = [...lstPIDs, pNum];
			} else {
				lstPIDs = [...lstPIDs, -1];
			}

			if (StudentCol >= 0) {
				lstSIDs = [...lstSIDs, next[StudentCol]];
			} else {
				lstSIDs = [...lstSIDs, "-1"];
			}

			if (this.IsSingleGroup == true) {
				lstGIDs = [...lstGIDs, this.SelectedGroup.GroupID];
				lstGNs = [...lstGNs, this.SelectedGroup.GroupName];
			} else {
				if (GroupIDCol >= 0) {
					var gNum = -1;

					try {
						gNum = Number(next[GroupIDCol]);

						if (gNum == undefined || gNum == null || Number.isNaN(gNum)) {
							gNum = -1;
						}
					} catch (e) {
						e.toString();
						gNum = -1;
					}

					lstGIDs = [...lstGIDs, gNum];
				} else {
					lstGIDs = [...lstGIDs, -1];
				}

				if (GroupNameCol >= 0) {
					lstGNs = [...lstGNs, next[GroupNameCol]];
				} else {
					lstGNs = [...lstGNs, "-1"];
				}
			}
		}

		var parms: GroupImportLoadDataRequest = {
			lstPersonIDs: lstPIDs,
			lstStudentIDs: lstSIDs,
			lstGroupIDs: lstGIDs,
			lstGroupNames: lstGNs,
		};

		//#endreigon
		//

		//
		//#region Call WS
		//
		var result = this.groupService.GroupImportLoadStudentData(parms);
		result.subscribe(
			(response) => {
				this.SetStatus(7);
				this.ShowColumnTable = false;
				this.ShowStudentTable = true;
				this.lstStudentTable = response;
			},
			(error) => {}
		);
		//#endreigon
		//
	}

	OnFinishConfirmGroupActionOption() {
		this.SetStatus(8);
		this.UploadStudentData();
	}

	UploadStudentData() {
		var lstPIDs: number[] = [];
		var lstGIDs: number[] = [];

		for (var z = 0; z < this.lstStudentTable.length; z++) {
			var next = this.lstStudentTable[z];

			if (next.Successful == true) {
				var Found = false;
				for (var x = 0; x < lstPIDs.length; x++) {
					var pID = lstPIDs[x];

					if (pID == next.PersonID) {
						Found = true;
						break;
					}
				}

				if (!Found) {
					lstPIDs = [...lstPIDs, next.PersonID];
					lstGIDs = [...lstGIDs, next.GroupID];
				}
			}
		}

		if (lstPIDs.length == 0) {
			this.errorMessage = "No Valid Entries";
			this.SetStatus(0);
			this.IsSingleGroup = false;
			return;
		}

		var parms: GroupImportInsertStudentsRequest = {
			lstPersonIDs: lstPIDs,
			lstGroupIDs: lstGIDs,
			AddGroupActions: this.AddGroupActions == true ? 1 : 0,
		};

		var result = this.groupService.GroupImportInsertStudents(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					this.SetStatus(9);

					//Success Dialog
					this.confirmationService.confirm({
						key: "importgroup",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: parms.lstPersonIDs.length + " students were added successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					this.errorMessage = response.Message;
					this.IsSingleGroup = false;
					this.SetStatus(0);
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////////////////////////////////////////

	//
	//#region Load Files
	//
	onFileToImportChange(val) {
		this.errorMessage = "";
		this.HideAllTable();
		this.lstColumnTable = [];
		this.lstStudentTable = [];
		this.AddGroupActions = false;

		this.File = val.target.files[0];
		this.FileName = this.File.name;

		try {
			var fr = new FileReader();
			fr.readAsBinaryString(this.File); //Get string w/ line breaks
			fr.onload = () => {
				this.TextData = fr.result;

				this.ReadFile();
			};
		} catch (e) {
			this.SetStatus(0);
			this.errorMessage = "Invalid File. Accepted formats are: Single Column .txt or .csv, Tab Delimited .txt, Comma Delimited .txt or .csv";
		}
	}

	HideAllTable() {
		this.ShowColumnTable = false;
		this.ShowStudentTable = false;
	}

	ReadFile() {
		this.Format = "Invalid";

		//
		//#region Check File Format by reading file
		//
		this.SetStatus(1);

		var Format = "Invalid";

		var FirstLineEndInd: number = 0;
		FirstLineEndInd = String(this.TextData).indexOf("\n");

		//No newline chars (Only 1 line of data)
		if (FirstLineEndInd < 0) {
			FirstLineEndInd = this.TextData.length;
		}

		var FirstLine = String(this.TextData).substr(0, FirstLineEndInd);

		var ContainsTab = FirstLine.indexOf("\t") > 0;
		var ContainsComma = FirstLine.indexOf(",") > 0;

		if (ContainsTab == false && ContainsComma == false) {
			Format = "SingleLine";
		} else if (ContainsTab == true) {
			Format = "Tab";
		} else if (ContainsTab == false && ContainsComma == true) {
			Format = "Comma";
		} else {
			this.SetStatus(0);
			this.errorMessage = "Invalid File Format";
			return;
		}

		//#endregion
		//

		//
		//#region Parse File into Column Table
		//
		this.SetStatus(2);

		this.lstColumnTable = [];

		var InQuotes: any = false;
		var nextRow: any = [];
		var nextCol: any = "";
		var checkedBOM: boolean = false;
		for (var z = 0; z < this.TextData.length; z++) {
			var next = this.TextData[z];

			// console.log(next + ", " + this.TextData.charCodeAt(z));

			if (next == "\n") {
				// console.log("New line");

				nextRow = [...nextRow, nextCol];
				this.lstColumnTable = [...this.lstColumnTable, nextRow];

				nextRow = [];
				nextCol = "";
			} else if (Format == "Tab" && next == "\t") {
				// console.log("Tab");

				nextRow = [...nextRow, String(nextCol)];
				nextCol = "";
			} else if (Format == "Comma" && InQuotes == false && next == ",") {
				// console.log("Comma");

				nextRow = [...nextRow, String(nextCol)];
				nextCol = "";
			} else if (next == '"') {
				// console.log("Quote");

				InQuotes = !InQuotes;
			} else if (next != "\r") {
				nextCol += next;

				// console.log("Normal Char (Format: " + Format + ", Quotes: " + InQuotes + ")");

				//
				// Remove Byte Order Mark from first line
				//
				if (nextRow.length == 0 && checkedBOM == false) {
					if (nextCol.length >= 2 && nextCol.length <= 4) {
						var ClearCol = false;

						//
						// Convert string to Byte array (best way to check for invalid characters)
						//
						var ByteArr: Number[] = [];

						for (var b = 0; b < nextCol.length; b++) {
							var nextChar = Number(nextCol.charCodeAt(b));
							// var nextByte = [nextChar & 0xff, (nextChar / 256) >>> 0];

							ByteArr = [...ByteArr, nextChar];
						}

						// console.log("Byte Arr");
						// console.log(ByteArr);

						if (nextCol.length == 2) {
							//UTF-16 BE
							if (ByteArr[0] == 254 && ByteArr[1] == 255) {
								ClearCol = true;
							}
							//UTF-16 LE
							else if (ByteArr[0] == 255 && ByteArr[1] == 254) {
								ClearCol = true;
							}
						} else if (nextCol.length == 3) {
							//UTF-1
							if (ByteArr[0] == 247 && ByteArr[1] == 100 && ByteArr[2] == 76) {
								ClearCol = true;
							}
							//UTF-7
							else if (ByteArr[0] == 43 && ByteArr[1] == 47 && ByteArr[2] == 118) {
								ClearCol = true;
							}
							//UTF-8
							else if (ByteArr[0] == 239 && ByteArr[1] == 187 && ByteArr[2] == 191) {
								ClearCol = true;
							}
							//SCSU
							else if (ByteArr[0] == 14 && ByteArr[1] == 254 && ByteArr[2] == 255) {
								ClearCol = true;
							}
							//BOCU-1
							else if (ByteArr[0] == 251 && ByteArr[1] == 238 && ByteArr[2] == 40) {
								ClearCol = true;
							}
						} else if (nextCol.length == 4) {
							//UTF-32 BE
							if (ByteArr[0] == 0 && ByteArr[1] == 0 && ByteArr[2] == 254 && ByteArr[3] == 255) {
								ClearCol = true;
							}
							//UTF-32 LE
							else if (ByteArr[0] == 255 && ByteArr[1] == 254 && ByteArr[2] == 0 && ByteArr[3] == 0) {
								ClearCol = true;
							}
							//UTF-EBCDIC
							else if (ByteArr[0] == 221 && ByteArr[1] == 115 && ByteArr[2] == 102 && ByteArr[3] == 115) {
								ClearCol = true;
							}
							//UTF-EBCDIC
							else if (ByteArr[0] == 132 && ByteArr[1] == 49 && ByteArr[2] == 149 && ByteArr[3] == 51) {
								ClearCol = true;
							}
						}

						//
						// Remove the Byte Order Mark
						//
						if (ClearCol == true) {
							nextCol = "";
							checkedBOM = true;
						}
					}
				}
			}
		}

		if (nextCol.length > 0 && nextCol != "\n" && nextCol != "\r") {
			nextRow = [...nextRow, String(nextCol)];
			nextCol = "";
		}
		if (nextRow.length > 0) {
			this.lstColumnTable = [...this.lstColumnTable, nextRow];
		}

		//#endregion
		//

		//
		//#region Get Column Data (Wait for User Input)
		//
		this.SetStatus(3);
		this.ShowColumnTable = true;
		//#endregion
		//
	}

	SetStatus(num) {
		try {
			if (num >= 0) {
				this.ImportStatusID = num;
				this.ImportStatusDesc = this.lstImportStatus[num].Desc;
				this.ImportStatusColor = this.lstImportStatus[num].Color;
			} else {
				this.ImportStatusID = 0;
				this.ImportStatusDesc = "Error";
				this.ImportStatusColor = "Red";
			}
		} catch (e) {
			this.ImportStatusID = 0;
			this.ImportStatusDesc = e.toString();
			this.ImportStatusColor = "Red";
		}
	}

	ReplaceAllOccur(source: string, searchFor: string, replaceWith: string): string {
		let ans: string = source;

		while (ans.indexOf(searchFor) != -1) {
			ans = ans.replace(searchFor, replaceWith);
		}

		return ans;
	}

	//#endregion
	//
}
